import { createContext, useContext } from "react";

import { MenuItemBadgesState } from "features/MenuItemBadges/types";

export const MenuItemBadgesContext = createContext<MenuItemBadgesState | null>(null);

export const useMenuItemBadgesContext = (): MenuItemBadgesState => {
    const state = useContext(MenuItemBadgesContext);

    if (!state) {
        throw new Error("useMenuItemBadgesContext должен использоваться внутри MenuItemBadges");
    }

    return state;
};
